/**
Author - Pradip Dhakal
Git - https://github.com/pradipwealthy
**/

import UploadMultipleDocuments from "./UploadMultipleDocuments.container";

export default UploadMultipleDocuments;